// GENERATED AUTOMATICALLY
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import AntdIcon, { AntdIconProps } from '../components/AntdIcon';
import { IconDefinition } from '../types';

const RulerOutlinedSvg: IconDefinition = {"icon":{"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","focusable":"false"},"children":[{"tag":"g","attrs":{"clip-path":"url(#clip0_123_5148)"},"children":[{"tag":"path","attrs":{"d":"M21 6H3a2 2 0 00-2 2v8c0 1.1.9 2 2 2h18a2 2 0 002-2V8a2 2 0 00-2-2zm0 10H3V8h2v4h2V8h2v4h2V8h2v4h2V8h2v4h2V8h2v8z","fill":"currentColor"}}]},{"tag":"defs","attrs":{},"children":[{"tag":"clipPath","attrs":{"id":"clip0_123_5148"},"children":[{"tag":"path","attrs":{"d":"M0 0h24v24H0z","fill":"#fff"}}]}]}]},"name":"ruler","theme":"outlined"};

const RulerOutlined = (
  props: AntdIconProps,
  ref: React.MutableRefObject<HTMLSpanElement>,
) => <AntdIcon {...props} ref={ref} icon={RulerOutlinedSvg} />;
  RulerOutlined.displayName = 'RulerOutlined';

export default React.forwardRef<HTMLSpanElement, AntdIconProps>(RulerOutlined);
